export { LoggedInConnectedESBanner } from './LoggedInConnectedESBanner';
